var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewLive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewLive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.499879,43.0848364 C317.248774,43.0848364 318.666534,41.6955678 318.666534,39.9818182 C318.666534,38.2680686 317.248774,36.8788 315.499879,36.8788 C313.750985,36.8788 312.333225,38.2680686 312.333225,39.9818182 C312.333225,41.6955678 313.750985,43.0848364 315.499879,43.0848364 Z M324.980954,39.8632727 C323.634588,35.7579636 319.824309,33 315.499879,33 C311.17545,33 307.365208,35.7579636 306.018842,39.8632727 C305.993719,39.9401818 305.993719,40.0234909 306.018842,40.1004 C307.365208,44.2057091 311.175487,46.9636727 315.499917,46.9636727 C319.824346,46.9636727 323.634588,44.2057091 324.980991,40.1004 C325.006077,40.0234909 325.006077,39.9401818 324.980954,39.8632727 Z M315.499879,45.4121455 C312.444145,45.4121455 309.958225,42.9761455 309.958225,39.9818545 C309.958225,36.9875636 312.444182,34.5515636 315.499879,34.5515636 C318.555577,34.5515636 321.041534,36.9875636 321.041534,39.9818545 C321.041534,42.9761455 318.555614,45.4121455 315.499879,45.4121455 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_OpenChat_keyboard-Copy-2",
    transform: "translate(-306.000000, -33.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icViewLive",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewLive);
export default __webpack_public_path__ + "static/media/icViewLive.53b2497cd4ba37cf27f28013cb614934.svg";
export { ForwardRef as ReactComponent };